import React from 'react'
import { withRouter } from 'react-router'
import { DI } from 'modules'

// Components
import SearchForm from 'components/search-form'

const HeaderView = props => {
  const {
    render = () => {},
    viewButton = () => {},
    history = [],
    buttonBackNameOfStr = '',
    common,
    user,
    defaultBackUrl = `/${common.locale}`,
    alwaysBackToDefault,
  } = props

  const goToLives = () =>
    history.length > 1 && !alwaysBackToDefault
      ? history.goBack()
      : history.push(defaultBackUrl)

  const currentAdminGroup = user.currentUser.payload.admin_group
  const isLive = !!props.liveEvent

  const videoAdminGroup =
    currentAdminGroup === 'super_admin' ||
    currentAdminGroup === 'output_editor' ||
    currentAdminGroup === 'client_desk' ||
    currentAdminGroup === 'seo_admin'
  const liveAdminGroup = videoAdminGroup || currentAdminGroup === 'live_admin'

  const adminGroup = isLive ? liveAdminGroup : videoAdminGroup

  return (
    <div className="live-top">
      <button className="page__back" onClick={goToLives} type="button">
        <span className="page__back--desk">
          {common.strings[buttonBackNameOfStr]}
        </span>
        <span className="page__back--mobile">
          {common.strings[buttonBackNameOfStr]}
        </span>
      </button>

      <div className="live-top__search">
        {!common.isMobile && <SearchForm />}
      </div>
      <div className="live-top-side">
        <div className="live-share">{render(props)}</div>
      </div>

      {adminGroup && viewButton(props)}
      <div className="live-top-side">
        <div className="live-share">{render(props)}</div>
      </div>
    </div>
  )
}

export default DI(['common', 'user'])(withRouter(HeaderView))
